exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:420px){.my-car-sale>.btn--green-ad{font-size:calc(.5vw + 6px)}}", ""]);

// exports
